// Serializes the heavy part of webcam captures (face detection + upload) so
// back-to-back kiosk enrollments can't interleave. The caller must freeze the
// frame (private canvas snapshot) BEFORE enqueueing — the queue only
// guarantees jobs run one at a time, in arrival order, and that one failing
// job never stalls the ones behind it.
export function createCaptureQueue(process) {
  let chain = Promise.resolve();
  return (job) => {
    const run = chain.then(() => process(job));
    // Keep the chain alive even when a job rejects.
    chain = run.catch(() => {});
    return run;
  };
}
